module.exports = __webpack_public_path__ + "d31f96f13c6a52323ca7af16c498d82a.png";